import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

/** Unauthenticated visitors are sent straight to the Azure AD B2C sign-in page (username/password),
 *  with no intermediate in-app login screen. Returning false cancels the navigation while the
 *  MSAL redirect takes over the page.
 *
 *  skipAuth=true (local convenience mode — see auth.interceptor.ts, which sends the unsigned
 *  local JWT in this mode) bypasses the MSAL gate entirely: the local BEs verify no signature,
 *  and forcing a real B2C login against local backends made the whole skipAuth mode unusable. */
export const authenticationGuard: CanActivateFn = () => {
  if (environment.skipAuth) return true;
  const auth = inject(AuthService);
  if (auth.authed()) return true;
  auth.login();
  return false;
};
